const bagHasKeys = (bag: unknown): boolean =>
    !!bag && typeof bag === 'object' && Object.keys(bag as object).length > 0;

export const arePanelTranslationsReady = (
    translations?: Record<string, unknown>,
    lcid?: number
): boolean => {
    if (!translations) {
        return false;
    }
    if (lcid != null) {
        return bagHasKeys(translations[String(lcid)] ?? translations[lcid]);
    }
    return Object.values(translations).some(bagHasKeys);
};
